'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowSpMenu = void 0;
const $ = require("jquery");
class ShowSpMenu {
    constructor() {
        $('.trigSwitchMenu').on('click', (e) => {
            const isOpen = $(e.currentTarget).attr('data-is-open');
            if (isOpen === 'false') {
                $(e.currentTarget).attr('data-is-open', 'true');
                $('.bulletSwitchMenu').attr('data-is-open', 'true');
            }
            else {
                $(e.currentTarget).attr('data-is-open', 'false');
                $('.bulletSwitchMenu').attr('data-is-open', 'false');
            }
        });
    }
}
exports.ShowSpMenu = ShowSpMenu;
exports.default = ShowSpMenu;
